// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	$(document).ready(function () {

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date)
		});

	});

	$('.slider-three-columns-slides').slick({
        accessibility:true,
        slidesToShow : 3,
        slidesToScroll:1,
        autoplay:true,
        autoplaySpeed:4000,
        speed:400,
        appendArrows: '#slider-three-columns-arrows',
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow : 2,
                    infinite: true,
                }
            },
            {
                breakpoint: 700,
                settings: {
                    slidesToShow : 1,
                    fade:true,
                    adaptiveHeight: false
                }
            }
        ]
    })

	// var longitud = document.querySelector('#svg_slider').getTotalLength();	
	// alert(longitud);

	window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

}());

//click menu
$("#btn-menu-js").click(function(){
	$(".menu-block").addClass("active");
	$(".header__container").addClass("fullmenu");
});
$(".menu-block__close").click(function(){
	$(".menu-block").removeClass("active");
	$(".header__container").removeClass("fullmenu");
});

//Map click list
$("#map-filter-brand").click(function(){
	document.querySelector("#map-filter-brand").classList.toggle("active");
	document.querySelector(".map__list--brand").classList.toggle("active");
});
$("#map-filter-state").click(function(){
	document.querySelector("#map-filter-state").classList.toggle("active");
	document.querySelector(".map__list--state").classList.toggle("active");
});
$("#map-filter-type").click(function(){
	document.querySelector("#map-filter-type").classList.toggle("active");
	document.querySelector(".map__list--type").classList.toggle("active");
});

(function(){
	let allAccordionItems = document.getElementsByClassName('js-accordion-title');
	let allALength = allAccordionItems.length;

	for(let i =0; i < allALength; i++){
		allAccordionItems[i].addEventListener('click', function(){
			let currentParent = this.parentElement;
			let currentCopyHeight = currentParent.getElementsByClassName('wrap')[0].clientHeight;
			let currentCopy = currentParent.getElementsByClassName('item-copy')[0]
			if(currentParent.classList.contains('open')){
				currentParent.classList.remove('open');
				currentCopy.style.height = '0';
			} else {
				currentParent.classList.add('open');
				currentCopy.style.height = (currentCopyHeight + 20) + 'px';
			}
		})
	}
}())


// //hover Menu
// var currentMenuItem = $("#privary-navigation a.active").parent().index();
// $(".navigation-gallery .slide:eq(" + currentMenuItem + ")").addClass("active");
// $("#privary-navigation > .privary-navigation__item > a").hover(function () {
// 	var hoverItem = $(this).parent().index();
// 	$(".navigation-gallery .slide").removeClass('active');
// 	$(".navigation-gallery .slide:eq(" + hoverItem + ")").addClass("active");
// });

document.addEventListener("DOMContentLoaded", function () {
	var showText = document.querySelector(".show-text");
	var hiddenText = document.querySelector(".hidden-text");

	if( showText ) {
		showText.addEventListener("click", function () {
			showText.classList.toggle("active");
			hiddenText.classList.toggle("hidden");
			if(showText.classList.contains('active')){
				showText.innerHTML="Close";
			}else {
				showText.innerHTML="Learn More";
			}
		});
	}
});
// Main Nav Dropdown
$("#primary-nav li").hover(function(){
	$(this).addClass("hover");
	$('ul.submenu',this).addClass("hover");
}, function(){
	$(this).removeClass("hover");
	$('ul.submenu',this).removeClass("hover");
});

// Main Nav Dropdown
$("#column-slides article").hover(function(){
	$(this).addClass("hover");
}, function(){
	$(this).removeClass("hover");
});

// Main Nav Dropdown
$(".columns-team-slides article").hover(function(){
	$(this).addClass("hover");
}, function(){
	$(this).removeClass("hover");
});


function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}